import get from "lodash.get";
import IntlUtils from "services/intl/utils";

class GlobalFiltersUtils {
  static getStatsByKey = (state, subStateKey, key) => {
    if (!state || !subStateKey || !key) {
      return "";
    }

    const subState = state[subStateKey] || {};
    return subState[key];
  };

  static getParkStatsByKey = (subStateKey, key) => {
    const store = require("../../store").applicationStore;
    if (!store) {
      return "";
    }

    const state = store.getState().ParkStatistics;
    return GlobalFiltersUtils.getStatsByKey(state, subStateKey, key);
  };

  static getPedestrianStatsByKey = (subStateKey, key) => {
    const store = require("../../store").applicationStore;
    if (!store) {
      return "";
    }

    const state = store.getState().PedestrianStatistics;
    return GlobalFiltersUtils.getStatsByKey(state, subStateKey, key);
  };

  static formatFiltersFromApi = (filters) => {
    const intl = IntlUtils.getIntlInstance();

    return filters.map((filter) => {
      return {
        text: intl.messages[`area.type.${get(filter, "name", "")}`],
        value: get(filter, "name", ""),
        defaultSelected: get(filter, "default_value", false) === "true",
      };
    });
  };
}

export default GlobalFiltersUtils;
